import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../../../environments/environment';
import { DataService } from '../../services/data.service';
import { bookmarksModalParams } from '../../constants/bookmrks-modal-params';
import { BookmarksModal } from './bookmarks-modal/bookmarks-modal';


@Component({
  selector: 'app-widget-bookmarks',
  templateUrl: './widget-bookmarks.html',
  styleUrls: ['./widget-bookmarks.scss']
})
export class WidgetBookmarks implements OnInit {
  @Input({ required: true }) widgetData: any;

  selectedBookmarks: Array<any> = [];
  allBookmarks: Array<any> = [];
  isLoading: boolean = false;
  isPopupLoading: boolean = false;
  popupOpened: boolean = false;

  constructor(
    private dataService: DataService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.getUserBookmarks();
  }

  getUserBookmarks() {
    this.isLoading = true;
    let url = environment.apiUrl + '/Portal/Bookmarks-Api/GetUserBookmarks';

    let request: any = {
      cultureCode: this.dataService.getCultureCode(),
      maxItemsCount: this.widgetData.maxDisplayItems
    };
    
    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData: Array<any>) => {
        this.selectedBookmarks = responseData;
        this.isLoading = false;
      },
      error: (e: any) => {
        console.error(e);
        this.isLoading = false;
        this.selectedBookmarks = [];
      },
    });
  }

  openPopup() { 
    if(this.dialog.openDialogs.length > 0) return;

    const modalData = {
      selectedbookmarksIds: this.selectedBookmarks.map(x => x.id),
      popupTitle: this.widgetData.popupTitle,
      cancelButtonText: this.widgetData.cancelButtonText,
      saveButtonText: this.widgetData.saveButtonText,
      maxItemsNumber: this.widgetData.maxDisplayItems
    }

    const dialogRef = this.dialog.open(BookmarksModal,
      {
        ...bookmarksModalParams,
        data: modalData
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      if(result?.updatedBookmarks)
        this.selectedBookmarks = result.updatedBookmarks;
    });
  }
}
